import { useMemo } from 'react';
import type { VFC } from 'react';

import { Helmet } from 'react-helmet';
import type { Thing, WithContext } from 'schema-dts';

type Props = {
  children?: WithContext<Thing> | (WithContext<Thing> | undefined)[];
};

export const StructuredData: VFC<Props> = ({ children }) => {
  const data = useMemo(() => {
    const array = Array.isArray(children) ? children : [children];
    const items = array.filter((i) => Boolean(i));

    return items.length > 0 && JSON.stringify(items);
  }, [children]);

  if (!data) {
    return null;
  }

  return (
    <Helmet>
      <script type="application/ld+json">{data}</script>
    </Helmet>
  );
};
